import React from 'react';
import { useStore } from '../../store';
import { getSymbolContext } from '../../selectors/symbolContext';

export function LiquidityPanel({ symbol }: { symbol: string }) {
  const { symbolData, settings, weights } = useStore();
  const data = symbolData[symbol];
  if (!data?.candles?.length) return (
    <div className="card">
      <div className="sl">Liquidity Map</div>
      <div className="empty"><div className="icon">🗺</div><h3>No Data</h3><p>Import OHLCV data to detect liquidity zones.</p></div>
    </div>
  );

  const zones = getSymbolContext(symbol, data, settings, weights)?.zones ?? [];
  const curPrice = data.candles[data.candles.length - 1].close;
  const typeColor = { resistance: 'var(--red)', support: 'var(--green)', key: 'var(--amber)' };
  const sigStyle = { High: { color: 'var(--red)' }, Medium: { color: 'var(--amber)' }, Low: { color: 'var(--t3)' } };
  const typeIcon = { resistance: '▲', support: '▼', key: '◆' };

  return (
    <div className="card">
      <div className="sl">Liquidity Map — {zones.length} zones</div>
      <div className="flex gap10 mb8" style={{ fontSize: 11, color: 'var(--t2)' }}>
        <span>▲ <span style={{ color: 'var(--red)' }}>Resistance</span></span>
        <span>▼ <span style={{ color: 'var(--green)' }}>Support</span></span>
        <span>◆ <span style={{ color: 'var(--amber)' }}>Key</span></span>
        <span style={{ marginLeft: 'auto', color: 'var(--t3)' }}>Current: <span className="mono" style={{ color: 'var(--t1)' }}>{curPrice.toFixed(2)}</span></span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 500, overflowY: 'auto' }}>
        {zones.map((zone, i) => {
          const isNear = zone.distPct < 0.4;
          const isAtLevel = zone.distPct < 0.12;
          return (
            <div key={i} className="card-inner" style={{
              borderLeft: `2px solid ${typeColor[zone.type]}`,
              background: isAtLevel ? 'rgba(45,156,219,.07)' : isNear ? 'rgba(255,255,255,.02)' : 'transparent',
            }}>
              <div className="fsb">
                <div className="flex gap6">
                  <span className="mono" style={{ fontSize: 14, fontWeight: 600, color: (typeColor as any)[zone.type] }}>{zone.price.toFixed(2)}</span>
                  {isAtLevel && <span className="badge b-blue" style={{ fontSize: 10 }}>IN PLAY</span>}
                  {zone.sig === 'High' && !isAtLevel && <span className="badge b-red" style={{ fontSize: 10 }}>HIGH</span>}
                </div>
                <div className="flex gap4">
                  <span style={{ fontSize: 10, ...(sigStyle[zone.sig] as any) }}>{(typeIcon as any)[zone.type]} {zone.sig}</span>
                  {zone.source === 'options' && <span className="badge b-purple" style={{ fontSize: 7 }}>OI</span>}
                </div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--t2)', marginTop: 2 }}>{zone.label}</div>
              <div className="inferred">{zone.reason}</div>
            </div>
          );
        })}
      </div>
      <div className="disclaimer mt8">Liquidity zones are inferred from price structure, OI, and statistical patterns. Not guaranteed fill locations.</div>
    </div>
  );
}
